import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideo } from '@fortawesome/free-solid-svg-icons'
import { Alert, Button, Typography } from 'antd'
import React, { FunctionComponent } from 'react'
import { useBrandContext } from '../../../../context/brand'
import { TMediaConstraints } from '../../../../context/types'
const { Paragraph } = Typography

type TProps = {
	connectToCall: (constraints: TMediaConstraints) => void
	goToDeviceSettings: () => void
	constraints: TMediaConstraints
}

const AllowPermissionsInstructions: FunctionComponent<TProps> = ({
	connectToCall,
	constraints,
	goToDeviceSettings,
}) => {
	const { brand } = useBrandContext()
	const getButtonText = () => {
		return !constraints?.video && !constraints?.audio ? 'camera and mic' : !constraints?.video ? 'camera' : 'mic'
	}
	const handleContinue = () => {
		!constraints?.audio && !constraints?.video ? connectToCall(constraints) : goToDeviceSettings()
	}
	return (
		<Alert
			showIcon
			type="warning"
			message="Permission to devices denied"
			style={{ margin: '20px 0' }}
			description={
				<Paragraph style={{ marginBottom: 0 }}>
					To get the most out of {brand.currentBrand.name}, please allow camera and mic permissions. In most browsers,
					look for a <FontAwesomeIcon icon={faVideo} /> or similar in the address bar.
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Button type="link" onClick={handleContinue}>
							Continue without {getButtonText()}
						</Button>
					</div>
				</Paragraph>
			}
		/>
	)
}

export default AllowPermissionsInstructions
